<template>
      <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>

       <v-flex xs4>
              <v-card  class="blue--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline"> {{$store.getters.artistas.length}} Artistas</div>                  
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn flat to="/artistas" >Veja Todos</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>


               <v-flex xs4>
            <v-card color="" class="blue--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">{{$store.getters.obras.length}} Obras</div>                  
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn flat  to="/obras">Gerencie</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>



               <v-flex xs4>
            <v-card  class="blue--text">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Próximos Lançamentos</div>
                  <span>Fique atento os lançamentos da semana e os listados no calendário</span>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn flat >Acompanhe o calendário</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>


    </v-layout>
  </v-container>

</template>

<script>
// @ is an alias to /src


export default {
  name: 'home',
  components: {

  }
}
</script>
